(function() {
  const TOAST_CONTAINER_ID = 'bxsi-toast-container';
  const TOAST_TIMEOUT = 4000;

  function ensureContainer() {
    let container = document.getElementById(TOAST_CONTAINER_ID);
    if (!container) {
      container = document.createElement('div');
      container.id = TOAST_CONTAINER_ID;
      container.className = 'fixed top-4 right-4 z-50 space-y-2 pointer-events-none sm:top-6 sm:right-6';
      document.body.appendChild(container);
    }
    return container;
  }

  function getToastStyles(type) {
    const styles = {
      success: {
        bg: 'bg-green-50',
        border: 'border-green-200',
        text: 'text-green-800',
        icon: '✓'
      },
      error: {
        bg: 'bg-red-50',
        border: 'border-red-200',
        text: 'text-red-800',
        icon: '⚠'
      },
      info: {
        bg: 'bg-navy/10',
        border: 'border-navy/20',
        text: 'text-navy',
        icon: 'ℹ'
      }
    };
    return styles[type] || styles.info;
  }

  window.toast = function(message, type = 'info', duration = TOAST_TIMEOUT) {
    const container = ensureContainer();
    const styles = getToastStyles(type);

    const toast = document.createElement('div');
    toast.className = `
      ${styles.bg} ${styles.border} ${styles.text}
      border rounded-lg px-4 py-3 shadow-md pointer-events-auto
      animate-slide-in-right max-w-sm
    `;
    toast.innerHTML = `
      <div class="flex items-start gap-3">
        <span class="text-lg font-bold flex-shrink-0">${styles.icon}</span>
        <p class="text-sm font-medium">${message}</p>
      </div>
    `;

    container.appendChild(toast);

    // Dismiss button
    const dismissBtn = document.createElement('button');
    dismissBtn.className = 'ml-auto flex-shrink-0 -mr-1 -mt-0.5 text-lg opacity-50 hover:opacity-100 transition-opacity';
    dismissBtn.innerHTML = '×';
    dismissBtn.type = 'button';
    dismissBtn.addEventListener('click', () => {
      toast.style.animation = 'slide-out-right 0.3s ease-in-out forwards';
      setTimeout(() => toast.remove(), 300);
    });
    toast.firstElementChild?.appendChild(dismissBtn);

    // Auto-dismiss
    const timeoutId = setTimeout(() => {
      if (toast.parentElement) {
        toast.style.animation = 'fade-out 0.3s ease-in-out forwards';
        setTimeout(() => toast.remove(), 300);
      }
    }, duration);

    toast.addEventListener('mouseenter', () => clearTimeout(timeoutId));
    toast.addEventListener('mouseleave', () => {
      setTimeout(() => {
        if (toast.parentElement) {
          toast.style.animation = 'fade-out 0.3s ease-in-out forwards';
          setTimeout(() => toast.remove(), 300);
        }
      }, duration / 2);
    });
  };

  // Add animations if not present
  if (!document.getElementById('bxsi-toast-styles')) {
    const style = document.createElement('style');
    style.id = 'bxsi-toast-styles';
    style.textContent = `
      @keyframes slide-in-right {
        from {
          opacity: 0;
          transform: translateX(100%);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }

      @keyframes slide-out-right {
        from {
          opacity: 1;
          transform: translateX(0);
        }
        to {
          opacity: 0;
          transform: translateX(100%);
        }
      }

      @keyframes fade-out {
        from {
          opacity: 1;
        }
        to {
          opacity: 0;
        }
      }

      .animate-slide-in-right {
        animation: slide-in-right 0.3s ease-out forwards;
      }
    `;
    document.head.appendChild(style);
  }
})();
